import React, { useState, useEffect } from "react";
import { Star } from "lucide-react";

const testimonialKeys = ["richard", "esteban", "igor"];

export function Testimonial({ t }) {
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % testimonialKeys.length);
        }, 6000);
        return () => clearInterval(interval);
    }, []);

    const key = testimonialKeys[activeIndex];
    const quote = t(`billing.testimonials.${key}.quote`);
    const name = t(`billing.testimonials.${key}.name`);
    const role = t(`billing.testimonials.${key}.role`);
    const initial = name?.charAt(0) || key.charAt(0).toUpperCase();

    return (
        <div className="bg-white rounded-2xl p-6 md:p-8 border border-slate-200 shadow-sm relative overflow-hidden">
            <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                ))}
            </div>

            <div className="min-h-[120px] relative">
                <blockquote key={activeIndex} className="text-slate-700 text-lg leading-relaxed mb-6 animate-fade-in">
                    "{quote}"
                </blockquote>
            </div>

            <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-indigo-500 to-violet-600 flex items-center justify-center text-white font-bold text-lg">
                    {initial}
                </div>
                <div>
                    <p className="font-semibold text-slate-900">{name}</p>
                    <p className="text-sm text-slate-500">{role}</p>
                </div>
            </div>

            <div className="flex justify-center gap-2 mt-4">
                {testimonialKeys.map((_, i) => (
                    <button
                        key={i}
                        onClick={() => setActiveIndex(i)}
                        className={`w-2 h-2 rounded-full transition-all ${i === activeIndex ? "bg-indigo-600 w-4" : "bg-slate-300"}`}
                        aria-label={`View testimonial ${i + 1}`}
                    />
                ))}
            </div>

            <div className="mt-6 pt-5 border-t border-slate-100 flex items-center gap-6">
                <div className="flex items-center gap-2">
                    <span className="text-2xl font-bold text-slate-900">8,000+</span>
                    <span className="text-sm text-slate-500">{t("billing.testimonial.companies") || "companies"}</span>
                </div>
                <div className="w-px h-8 bg-slate-200" />
                <div className="flex items-center gap-2">
                    <span className="text-2xl font-bold text-slate-900">10k+</span>
                    <span className="text-sm text-slate-500">{t("billing.testimonial.appsBuilt") || "apps built"}</span>
                </div>
            </div>

            <style>{`
                @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
                .animate-fade-in { animation: fadeIn 0.5s ease-out; }
            `}</style>
        </div>
    );
}
